import api from '@/api/base'

export default {
    login(pin) {
        return api().patch(`/survey/${pin}`);
    }
}